var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarmImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_569_5704)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_569_5704",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 165,
    height: 165
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165 0H0V165H165V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_569_5704)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165 0H0V165H165V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 147C128.01 147 149.5 125.51 149.5 99C149.5 72.4903 128.01 51 101.5 51C74.9903 51 53.5 72.4903 53.5 99C53.5 125.51 74.9903 147 101.5 147Z",
    fill: "#4A25A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7226 91.4778L86.8476 72.6001H76.2999L80.3772 88.3468H77.3635L91.8999 111L88.1772 91.4778H91.7226Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3227 102.278L72.4477 83.3999H61.9L65.9773 99.1467H62.9636L77.5 121.8L73.7773 102.278H77.3227Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.00011 165C-4.00014 165 -4.00008 165 -4.00011 165C8.70244 165 19 154.703 19 142C19 129.297 8.70254 119 -4.00001 119C-4.00004 119 -3.99998 119 -4.00001 119L-4.00011 165Z",
    fill: "#E4DEF2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165 0C152.297 -1.11049e-06 142 10.2974 142 23C142 35.7025 152.297 46 165 46V0Z",
    fill: "#E4DEF2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9999 165C31.7024 165 42 154.703 42 142C42 129.297 31.7025 119 19 119L18.9999 165Z",
    fill: "#E4DEF2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142 0C129.297 -1.11049e-06 119 10.2974 119 23C119 35.7025 129.297 46 142 46V0Z",
    fill: "#E4DEF2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24 81.2714C25.5208 81.8241 28.9486 82.4322 30.4928 80.4422C32.037 78.4523 32.3061 71.9849 32.2476 69C32.5401 72.1508 33.7919 78.5849 36.4592 79.1156C39.1265 79.6462 42.601 76.2412 44.0049 74.4724C42.601 76.2412 40.3197 80.3759 42.4255 82.7638C44.1913 84.7662 46.5982 84.6542 49.3643 84.2073C49.8846 84.0688 50.428 83.9766 51 83.9246C50.4428 84.0228 49.8969 84.1213 49.3643 84.2073C47.1178 84.8051 45.3022 86.2647 43.4784 89.0653C41.5137 92.0824 43.7916 97.5184 45.6851 100.757C45.9775 101.207 46.2388 101.626 46.4616 102C46.2197 101.64 45.9563 101.221 45.6851 100.757C43.5974 97.5478 39.9224 92.8299 37.3366 92.7136C34.9347 92.6055 32.6803 96.0125 31.3897 98.6836C31.1455 99.3029 30.8942 99.872 30.6683 100.342C30.8525 99.8604 31.0962 99.291 31.3897 98.6836C32.4099 96.0964 33.307 92.6337 31.7212 91.8844C29.7558 90.9558 26.4567 91.4975 25.0529 91.8844C26.1643 90.8894 28.3519 88.402 28.2115 86.4121C28.0712 84.4221 25.3454 82.1558 24 81.2714Z",
    fill: "#C7BBE4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7259 9.4043L13.0407 32.9101L22.1665 64.6232L35.8566 60.6837L43.1912 68.9788L44.995 58.054L103.852 41.1174L94.7259 9.4043Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_569_5704",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 9,
    width: 91,
    height: 60
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7259 9.4043L13.0407 32.9101L22.1665 64.6232L35.8566 60.6837L43.1912 68.9788L44.995 58.054L103.852 41.1174L94.7259 9.4043Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_569_5704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0407 32.9101L12.4876 30.9881L10.5656 31.5412L11.1187 33.4632L13.0407 32.9101ZM94.7259 9.40429L96.6479 8.85121L96.0948 6.9292L94.1728 7.48228L94.7259 9.40429ZM22.1665 64.6232L20.2445 65.1763L20.7975 67.0983L22.7195 66.5452L22.1665 64.6232ZM35.8566 60.6837L37.3549 59.3589L36.5179 58.4122L35.3036 58.7617L35.8566 60.6837ZM43.1912 68.9788L41.6929 70.3036L44.4792 73.4548L45.1645 69.3046L43.1912 68.9788ZM44.995 58.054L44.4419 56.132L43.2276 56.4815L43.0217 57.7282L44.995 58.054ZM103.852 41.1174L104.405 43.0394L106.327 42.4863L105.774 40.5643L103.852 41.1174ZM13.5938 34.8321L95.279 11.3263L94.1728 7.48228L12.4876 30.9881L13.5938 34.8321ZM24.0885 64.0701L14.9627 32.357L11.1187 33.4632L20.2445 65.1763L24.0885 64.0701ZM35.3036 58.7617L21.6134 62.7012L22.7195 66.5452L36.4097 62.6057L35.3036 58.7617ZM44.6895 67.654L37.3549 59.3589L34.3583 62.0085L41.6929 70.3036L44.6895 67.654ZM43.0217 57.7282L41.2179 68.653L45.1645 69.3046L46.9683 58.3798L43.0217 57.7282ZM103.299 39.1954L44.4419 56.132L45.5481 59.976L104.405 43.0394L103.299 39.1954ZM92.8039 9.95736L101.93 41.6704L105.774 40.5643L96.6479 8.85121L92.8039 9.95736Z",
    fill: "#4A25A9"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7488 31.2246L54.8103 30.3286L57.5738 39.7711C58.5087 42.9654 56.6931 45.787 53.0437 46.855C49.3942 47.9231 46.3642 46.5198 45.4293 43.3254L42.6657 33.883L45.7069 32.9929L48.3999 42.1943C48.8879 43.8618 50.4428 44.7372 52.2676 44.2031C54.1126 43.6631 54.9298 42.0935 54.4418 40.426L51.7488 31.2246Z",
    fill: "#4A25A9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5298 26.0205L73.7868 40.5658L71.1511 41.3372L61.999 33.9827L61.8773 34.0183L64.5821 43.2598L61.5408 44.1499L57.2838 29.6045L59.9601 28.8212L69.0717 36.1877L69.2136 36.1461L66.5089 26.9046L69.5298 26.0205Z",
    fill: "#4A25A9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1255 27.1237C82.3202 25.8762 80.9581 25.3588 79.3564 25.8276C77.0856 26.4922 76.0504 28.6709 76.9441 31.7246C77.8437 34.7984 79.8556 36.1072 82.1872 35.4248C84.2857 34.8106 85.1886 33.2704 84.6911 31.4203L81.508 32.3519L80.8436 30.0817L86.9665 28.2897L87.4957 30.0978C88.6129 33.915 86.6592 37.0168 82.949 38.1027C78.8332 39.3073 75.2003 37.2733 73.8538 32.6727C72.4721 27.9515 74.6411 24.3067 78.5135 23.1734C81.8183 22.2062 84.9609 23.4675 86.2072 26.2217L83.1255 27.1237Z",
    fill: "#4A25A9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1794 37.6118L29.408 45.7742L30.8745 45.345L31.6046 53.5732L35.0398 42.7565L33.7957 43.1206L33.7065 38.7531L36.2298 38.0211L36.2212 38.0236L36.2592 38.0125C37.3853 37.6829 38.563 38.3203 38.8896 39.4362C39.1792 40.4258 38.7022 41.4594 37.8051 41.9106L37.7041 41.9581C37.6199 41.995 37.5325 42.027 37.4419 42.0535L37.3577 42.0781L38.0028 44.2823L38.3958 44.2039C39.3946 44.1002 40.3536 44.7135 40.6432 45.7031C40.9698 46.819 40.3217 47.9908 39.1955 48.3204L37.8126 48.7251L36.921 51.4589L40.4123 50.437C42.7968 49.7392 44.1693 47.2579 43.4777 44.8951C43.1142 43.6528 42.2525 42.6906 41.1704 42.1588C41.7949 41.1274 42.0019 39.8524 41.6383 38.6102C40.9468 36.2473 38.4531 34.8976 36.0686 35.5955L29.1794 37.6118Z",
    fill: "#4A25A9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_569_5704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 165,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmImg);
export default __webpack_public_path__ + "static/media/alarmImg.6f1577f3f56cb1b74dc231868a46cafd.svg";
export { ForwardRef as ReactComponent };